<template>
  <component :is="layout"></component>
</template>

<script>
import LoginLayout from '@/components/layouts/Login';
import DashboardLayout from '@/components/layouts/DashboardLayout';
import { mapActions } from 'vuex';
import types from '@/types';

export default {
  name: 'App',

  components: {
    LoginLayout,
    DashboardLayout,
  },

  data() {
    return {
      layout: 'dashboard-layout',
    };
  },

  watch: {
    $route: {
      handler(router) {
        if (router.name === 'NotFound') {
          this.layout = 'login-layout';
          return;
        }
        if (router.path.startsWith('/user/gestor/')) {
          this.layout = 'dashboard-layout';
        } else if (router.path.startsWith('/user/')) {
          this.layout = 'login-layout';
        } else {
          this.layout = 'dashboard-layout';
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    ...mapActions({
      [types.GET_USER]: `${types.USER}/${types.GET_USER}`,
      [types.LOGOUT]: `${types.USER}/${types.LOGOUT}`,
      [types.REFRESH_TOKEN]: `${types.USER}/${types.REFRESH_TOKEN}`,
    }),
    handleLogout() {
      this[types.LOGOUT]().then(() => {
        this.$router.push({ name: 'Login', query: { reason: 'session-expired' } });
      });
    },
  },

  mounted() {
    if (localStorage.token) {
      this[types.GET_USER]().catch(async (error) => {
        if (error.response && error.response.status === 403 && localStorage.refresh) {
          try {
            await this[types.REFRESH_TOKEN](localStorage.refresh);
          } catch (err) {
            this.handleLogout();
          }
        } else {
          this.handleLogout();
        }
      });
    }
  },
};
</script>

<style>
.v-btn {
  text-transform:none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue